"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emptyParameter = void 0;
const types_1 = require("@framework/types");
exports.emptyParameter = {
    parameterName: "",
    parameterType: types_1.ParameterType.STRING,
    parameterValue: "",
    parameterMinValue: "",
    parameterMaxValue: "",
};
//# sourceMappingURL=empty-parameter.js.map